import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'store';

const selectSelf = (state: RootState) => state;

const selectStartDateTime = createSelector(
  selectSelf,
  (state) => state.purchaseInvoices.startDate
);
const selectEndDateTime = createSelector(
  selectSelf,
  (state) => state.purchaseInvoices.endDate
);

export const selectStartDate = createSelector(
  selectStartDateTime,
  (startDateTime) => (startDateTime ? new Date(startDateTime) : null)
);
export const selectEndDate = createSelector(selectEndDateTime, (endDateTime) =>
  endDateTime ? new Date(endDateTime) : null
);

export const selectBankAccount = createSelector(
  selectSelf,
  (state) => state.purchaseInvoices.bankAccount
);
